import { Box, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const Container = styled(Box)`
  .MuiFormControl-root {
    width: 291px;
    ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;
  `}
  }
  ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;
  `}
`;
